// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610010036/js/" + chunkId + "." + {"44":"d2adeaba","225":"a20f5a33","481":"b2cda0ae","486":"ed97acf6","770":"2ba3f289"}[chunkId] + ".0.47908208150780285.chunk.js";
};